import { render, staticRenderFns } from "./mail_send.vue?vue&type=template&id=f1b53b2a&scoped=true&"
import script from "./mail_send.vue?vue&type=script&lang=js&"
export * from "./mail_send.vue?vue&type=script&lang=js&"
import style0 from "./mail_send.vue?vue&type=style&index=0&id=f1b53b2a&scoped=true&lang=less&"
import style1 from "./mail_send.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b53b2a",
  null
  
)

export default component.exports